import { IamPermissionAnswer } from "models/iam/iam-answer";

export const hasAccess = (
  permission: string,
  answer: IamPermissionAnswer[]
): boolean => {
  let match: boolean = false;

  for (let i = 0; i < answer.length; i++) {
    if (answer[i].name === permission) {
      match = answer[i].access;
      break;
    }
  }

  return match;
};



// WEBPACK FOOTER //
// ./src/app/access-control/permission-verification.ts